import { render, staticRenderFns } from "./PaypalCallback.vue?vue&type=template&id=08c0cc9f&"
import script from "./PaypalCallback.vue?vue&type=script&lang=js&"
export * from "./PaypalCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports